import { PhoneBox } from '@apply/components';
import { usePaymentStore } from '../../../../../state/paymentStore';

export const Phone: React.FC = () => {
    const phone = usePaymentStore((s) => s.phone);
    const set_phone = usePaymentStore((s) => s.set_phone);

    return (
        <PhoneBox
            value={phone}
            onChange={(value) => set_phone(value)}
            label='Phone'
            required={true}
        />
    );
};
